export const FOODICS_PRICE_WITH_VAT_SESSION_KEY = 'foodics_price_with_vat';

export const setFoodicsPriceWithVatSession = (value: boolean) => {
  if (typeof window === 'undefined') return;
  window.sessionStorage.setItem(FOODICS_PRICE_WITH_VAT_SESSION_KEY, String(value));
};

export const getFoodicsPriceWithVatSession = (): boolean | null => {
  if (typeof window === 'undefined') return null;

  const storedValue = window.sessionStorage.getItem(FOODICS_PRICE_WITH_VAT_SESSION_KEY);
  if (storedValue === 'true') return true;
  if (storedValue === 'false') return false;

  return null;
};

export const clearFoodicsPriceWithVatSession = () => {
  if (typeof window === 'undefined') return;
  window.sessionStorage.removeItem(FOODICS_PRICE_WITH_VAT_SESSION_KEY);
};
